import { useMutation } from '@tanstack/react-query';
import { authService } from 'shared/src/api';

export const usePostKakaoLogin = () => {
  return useMutation({
    mutationFn: authService.postKakaoLogin,
    throwOnError: false,
  });
};
